<template>
  <div class="home"></div>
</template>

<script>
export default {
  created() {
    setTimeout(() => {
      this.$router.replace("begin");
    }, 4000);
  }
};
</script>

<style lang="scss" scoped>
.home {
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  background: url("~@/assets/img/bg1.gif") no-repeat center bottom;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
